import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { type ThemeId } from '../schema/ThemeId';

const getThemeNameMap = () => {
    const strings = getOwaMiniCommonStrings();
    return {
        ['Blue']: strings.blueColorThemeLabel,
        ['Purple']: strings.purpleColorThemeLabel,
        ['Pink']: strings.pinkColorThemeLabel,
        ['Orange']: strings.orangeColorThemeLabel,
        ['Red']: strings.redColorThemeLabel,
        ['Green']: strings.greenColorThemeLabel,

        ['Afghanistan']: strings.afghanistanCricketThemeLabel,
        ['Australia']: strings.australiaCricketThemeLabel,
        ['Bangladesh']: strings.bangladeshCricketThemeLabel,
        ['Canada']: strings.canadaCricketThemeLabel,
        ['England']: strings.englandCricketThemeLabel,
        ['India']: strings.indiaCricketThemeLabel,
        ['Ireland']: strings.irelandCricketThemeLabel,
        ['Namibia']: strings.namibiaCricketThemeLabel,
        ['Nepal']: strings.nepalCricketThemeLabel,
        ['Netherlands']: strings.netherlandsCricketThemeLabel,
        ['NewZealand']: strings.newZealandCricketThemeLabel,
        ['Oman']: strings.omanCricketThemeLabel,
        ['Pakistan']: strings.pakistanCricketThemeLabel,
        ['PapuaNewGuinea']: strings.papuaNewGuineaCricketThemeLabel,
        ['Scotland']: strings.scotlandCricketThemeLabel,
        ['SouthAfrica']: strings.southAfricaCricketThemeLabel,
        ['SriLanka']: strings.sriLankaCricketThemeLabel,
        ['Uganda']: strings.ugandaCricketThemeLabel,
        ['USA']: strings.usaCricketThemeLabel,
        ['WestIndies']: strings.westIndiesCricketThemeLabel,

        ['Athletics']: strings.athleticsThemeLabel,
        ['Basketball']: strings.basketballThemeLabel,
        ['Boxing']: strings.boxingThemeLabel,
        ['Football']: strings.footballThemeLabel,
        ['Gymnastics']: strings.gymnasticsThemeLabel,
        ['Handball']: strings.handballThemeLabel,
        ['Swimming']: strings.swimmingThemeLabel,
        ['Tennis']: strings.tennisThemeLabel,
        ['Volleyball']: strings.volleyballThemeLabel,
        ['Weightlifting']: strings.weightliftingThemeLabel,

        ['ArcticSolitude']: strings.arcticSolitudeThemeLabel,
        ['MarigoldHills']: strings.marigoldHillsThemeLabel,
        ['NatureUndefined']: strings.natureUndefinedThemeLabel,
        ['OpenSkyscape']: strings.openSkyscapeThemeLabel,
        ['RubyHills']: strings.rubyHillsThemeLabel,
    };
};

export const getThemeName = (themeId: ThemeId): string => {
    const themeNameMap = getThemeNameMap();
    return themeNameMap[themeId];
};
